import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Flex, useColorModeValue } from "@chakra-ui/react";

import {
  CONDOMINIUM_FORM_COMPONENTS_PER_TYPE, CONDOMINIUM_FORM_LEGENDS_PER_TYPE
} from "components/Condominiums/CondominiumForm/constants";
import {
  CondominiumFormType
} from "components/Condominiums/CondominiumForm/types";

export const SaveCondominium = () => {
  const { id } = useParams();
  const [type, setType] = useState<CondominiumFormType>("create");

  const CondominiumFormComponent = CONDOMINIUM_FORM_COMPONENTS_PER_TYPE[type];
  const CondominiumFormLegendComponent = CONDOMINIUM_FORM_LEGENDS_PER_TYPE[
    type
  ];

  function setupForm() {
    if (id) {
      setType("edit");
    }
  }

  useEffect(() => {
    setupForm();
  }, [id]);

  return (
    <Flex
      bg={useColorModeValue("gray.50", "gray.800")}
      justifyContent={"left"}
      padding={5}
    >
      <Box width="100%">
        <Box textAlign={"left"} py={10} px={2}>
          <CondominiumFormLegendComponent />
        </Box>
        <Box
          margin={2}
          display="flex"
          flexDirection={{
            base: "column-reverse",
            lg: "row"
          }}
          gap={10}
          justifyContent={{
            base: "center",
            lg: "space-between"
          }}
        >
          <CondominiumFormComponent />
        </Box>
      </Box>
    </Flex>
  );
};
